export const AbsObjectValues = (obj, fields) => {
  const result = { ...obj };
  Object.keys(obj).forEach((key) => {
    if (fields.includes(key)) {
      result[key] = Math.abs(obj[key]);
    }
  });
  return result;
};

export const parseDateWithoutTimezone = (dateString) => {
  const clean = dateString.replace('Z', '');
  return new Date(clean);
};


export function formatFrenchDate(dateString) {
  if(!dateString || dateString == 'undefined') return '--/--/----';
  return dateString ? new Intl.DateTimeFormat("fr-FR").format(new Date(dateString)) : '--/--/----';
}

export function formatFrenchDateTime(dateString) {
  const date = new Date(dateString);

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  return new Intl.DateTimeFormat("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}